"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sanitizeUrl = void 0;
var invalidProtocolRegex = /((\w*\W+)|(^))(javascript|data|vbscript)/im;
var invalidTextRegex = /(javascript|data|vbscript):/im;
var htmlEntitiesRegex = /&#(\w+)(^\w|;)?/g;
var ctrlCharactersRegex = /[\u0000-\u001F\u007F-\u009F\u2000-\u200D\uFEFF]/gim;
var urlSchemeRegex = /^([^:]+):/gm;
var relativeFirstCharacters = ['/'];
function isRelativeUrlWithoutProtocol(url) {
  return relativeFirstCharacters.indexOf(url[0]) > -1 && !invalidTextRegex.test(url);
}
// adapted from https://stackoverflow.com/a/29824550/2601552
function decodeHtmlCharacters(str) {
  return str.replace(htmlEntitiesRegex, function (match, dec) {
    return String.fromCharCode(dec);
  });
}
function sanitizeUrl(url, defaultURL) {
  if (defaultURL === void 0) {
    defaultURL = 'about:blank';
  }
  var sanitizedUrl = decodeHtmlCharacters(url || '').replace(ctrlCharactersRegex, '').trim();
  if (!sanitizedUrl) {
    return defaultURL;
  }
  if (isRelativeUrlWithoutProtocol(sanitizedUrl)) {
    return sanitizedUrl;
  }
  var urlSchemeParseResults = sanitizedUrl.match(urlSchemeRegex);
  if (!urlSchemeParseResults) {
    return "/".concat(sanitizedUrl);
  }
  var urlScheme = urlSchemeParseResults[0];
  if (invalidProtocolRegex.test(urlScheme)) {
    return defaultURL;
  }
  return "/".concat(sanitizedUrl);
}
exports.sanitizeUrl = sanitizeUrl;